import { useEffect, useState } from 'react';

export default function TimeoutStream ({ dataChannel }) {
    const [isFastRefresh, setFastRefresh] = useState(false);
    const [doesRefresh, setDoesRefresh] = useState(true);

    useEffect(() => {
        function refresh() {
            if(dataChannel.readyState === 'open') {
                const array = new Uint16Array(1);
		array[0] = isFastRefresh ? 90 : 500;
                dataChannel.send(array);
            }
        }

	if(doesRefresh) {
            const interval = setInterval(refresh, 35);
            return () => clearInterval(interval);
        }
    }, [dataChannel, isFastRefresh, doesRefresh]);

    function toggleFastOrSlowRefresh() {
        setFastRefresh((isFastRefresh) => !isFastRefresh);
    }

    function toggleOnOrOffRefresh() {
        setDoesRefresh((doesRefresh) => !doesRefresh);
    }

    const buttonText1 = isFastRefresh ? "Change to Long timeout" : "Change to Short timeout";
    const buttonText2 = doesRefresh ? "Turn timeout Off" : "Turn timeout On";

    return <>
        <div className="col-6 text-center p-2">
            <button className="btn btn-primary" onClick={toggleFastOrSlowRefresh}>{buttonText1}</button>
            <button className="btn btn-primary" onClick={toggleOnOrOffRefresh}>{buttonText2}</button>
        </div>
    </>;
}
